import React, { useState } from 'react';
import { Drawer, Button, Icon, Intent } from '@blueprintjs/core';
import styled from 'styled-components';
import colors from 'utils/colors';
import { PlainButton, DrawerHeader } from 'components/styled-components';
import EditAssessment from 'components/vendor-requests/edit-assessment';
import { updatePrescreeningAnswers } from 'api/vendor-request';
import { AppToaster } from 'components/AppToaster';
import Loading from 'components/loading';

const PrescreenDrawer = ({
  instance,
  vendorRequestID,
  fetchPrescreenInstance,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [updatedValues, setUpdatedValues] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const closeDrawer = () => setIsOpen(false);
  const openDrawer = () => setIsOpen(true);

  const shareValuesWithParent = values => {
    setUpdatedValues(values);
  };

  // This makes sure all of our questions have an answer
  // Note: This will be "false" until something changes, which works with our workflow of using this function
  const allQuestionHaveValues = () => {
	let theAnswer = instance.reduce((endResult, question) => {
		if(endResult === false) return false; // if ANY are empty, return false
		return question.answers.filter(qa => updatedValues.includes(qa.answerID)).length > 0;
	}, true);

	return theAnswer
  };

  const saveAssessment = () => {
    setSubmitting(true);
    updatePrescreeningAnswers(vendorRequestID, updatedValues)
      .then(res => {
        fetchPrescreenInstance(vendorRequestID);
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        closeDrawer();
        setSubmitting(false);
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        closeDrawer();
        setSubmitting(false);
      });
  };

  const allQuestionsAnswered = allQuestionHaveValues();

  return (
    <React.Fragment>
      <PlainButton type="button" onClick={openDrawer}>
        edit active assessment
      </PlainButton>
      <Drawer isOpen={isOpen} onClose={closeDrawer}>
        <DrawerHeader>
          <span>Edit Active Assessment</span>
          <div style={{ display: 'flex' }}>
            <Button minimal text="CANCEL" onClick={closeDrawer} />
            <PlainButton
              display="flex"
              onClick={saveAssessment}
              disabled={
				  !allQuestionsAnswered
				  && !submitting
			  }
            >
              save
              {submitting && (
                <span style={{ marginLeft: '1rem' }}>
                  <Loading size={20} />
                </span>
              )}
            </PlainButton>
          </div>
        </DrawerHeader>
        <Callout>
          <Icon
            icon="issue"
            color={colors.primary}
            iconSize={20}
            style={{ marginRight: 10 }}
          />
          <strong>Alert! </strong> Changes made to an active assessment may
          require new questions to be answered by the third party contact.
        </Callout>
        <EditAssessment
          instance={instance}
          shareValuesWithParent={shareValuesWithParent}
        />
      </Drawer>
    </React.Fragment>
  );
};

const Callout = styled.div`
  padding: 1.5rem;
  background: #e5f3ff;
  text-align: center;
`;

export default PrescreenDrawer;
